module.exports = __webpack_public_path__ + "img/9I.9c24afdf.png";